export { default as PhotoGallery } from "./PhotoGallery";
